import React, {useRef, useState, useEffect} from 'react';
import {
  Form,
  Tab,
  Tabs,
  Table,
  Button,
  Modal,
  Card,
  Spinner
} from 'react-bootstrap';
import {PfButton} from '@profabric/react-components';
import Select from 'react-select';
import {read, utils, write} from 'xlsx';
import * as AuthService from '../../../services/auth';
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import {DateTimePicker} from 'react-tempusdominus-bootstrap';
import {SelectedBox} from '../../car/MapElement';
import FileSaver from 'file-saver';
import {toast} from 'react-toastify';
import DirectChat from '../../car/DirectChat';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import ModalAddPic from '../../car/modal/ModalAddPic';
import PhotoStamp from '../../car/PhotoStamp';
import {InputGroup} from 'react-bootstrap';
import FolkliftCers from '../FolklifitCers';
import styled from 'styled-components';
import {PfImage} from '@profabric/react-components';
import {useSelector} from 'react-redux';
import {log} from 'console';

const ItemMember = (props) => {
  const StyledUserImage = styled(PfImage)``;
  return (
    <Card className="card bg-light">
      <Card.Body>
        <div className="col-12">
          <div className="row">
            <div className="col-2">
              <StyledUserImage
                src={props.img}
                fallbackSrc="/img/default-profile.png"
                width={48}
                height={48}
                rounded
              />
            </div>
            <div className="col-8">
              {`${props.index}. `} {props.name}
            </div>
            <div className="col-2">
              {props.mode === 'add' ? (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onAdd(props.empid, props.name, props.img);
                  }}
                >
                  &nbsp;&nbsp;เพิ่ม&nbsp;&nbsp;
                </Button>
              ) : (
                <Button
                  className="btn-xs"
                  variant="outline-primary"
                  onClick={() => {
                    props.onDelete(props.empid);
                  }}
                >
                  &nbsp;&nbsp;ลบ&nbsp;&nbsp;
                </Button>
              )}
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default function ModalSetCourse(props) {
  const user = useSelector((state) => state.auth.currentUser);
  const [search2, setSearch2] = useState('');
  const [search3, setSearch3] = useState('');
  const dispatch = useDispatch();
  const [min, setMin] = useState(null);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [showMd4, setShowMd4] = useState(false);
  const [max, setMax] = useState();
  const [step, setStep] = useState(1);
  const [stepScore, setStepScore] = useState(1);
  const [stepTrainer, setStepTrainer] = useState(1);
  const [error, setError] = useState('');
  const [key, setKey] = useState('training');
  const [dropdownExpense, setDropdownExpense] = useState([]);
  const [dropdownGroup, setDropdownGroup] = useState([]);
  const [dropdownTrainerType, setDropdownTrainerType] = useState([]);
  const [dropdownPlace, setDropdownPlace] = useState([]);
  const [dropdownType, setDropdownType] = useState([]);
  const [members2, setMembers2] = useState([]);
  const [members, setMembers] = useState([]);
  const [chat, setChat] = useState([]);
  const [style, setStyle] = useState('lightbox');
  const [photo, setPhoto] = useState([
    {
      src: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      original: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      downloadUrl: `https://cdn-icons-png.flaticon.com/512/911/911033.png`,
      caption: `TEMP`,
      alt: `TEMP`
    }
  ]);
  const [training, setTrainging] = useState({
    TRAINING_NAME: '',
    TRAINING_GROUP_NAME: '',
    TRAINING_DIVISION: '',
    TRAINING_FIELD: '',
    TRAINING_INSTRUCTOR: '',
    TRAINING_INSTRUCTOR_NAME: '',
    TRAINING_VENUE: '',
    TRAINING_DATE: new Date(),
    TRAINING_DATE2: new Date(),
    TRAINING_TIME_START: new Date(),
    TRAINING_TIME_END: new Date(),
    TRAINING_EXPIRED_DATE: null,
    TRAINING_TOTAL_SCORE: 100,
    IS_ACTIVE: '',
    TRAINING_ZOOM_URL: '',
    TRAINING_REG_START: new Date(),
    TRAINING_REG_END: new Date(),
    MAIL_SUBJECT: 'FYI : ขอเชิญเข้าร่วมหลักสูตรการอบรมภายใน (By HRD)',
    MAIL_BODY:
      'ตามที่ฝ่าย HRD ได้ทำการสร้างหลักสูตรการอบรมและเชิญท่านเข้าร่วมอบรมโดยรายละเอียดดังตารางด้านล่างนี้',
    TRAINING_TYPE: '',
    TRAINING_GROUP: '',
    TRAINING_INSTRUCTOR_TYPE: '',
    TRAINING_TYPE_V2: '',
    TRAINING_PLACE: '',
    TRAINING_RATING: 0,
    TRAINING_COMMENT: '',
    TRAINING_DOC_URL: '',
    TRAINING_HOUR: 0,
    TRAINEE: [],
    EXPENSE: [],
    SCORE: [],
    TRAINER: [],
    RELATED: [],
    TRAINING_CERT_NO: ''
  });

  const [panel, setPanel] = useState({
    isMe: false,
    isCancelable: false,
    isEditable: false,
    isApprovable: false,
    isRejectable: false
  });

  const uploadPicWs = async (input, file) => {
    try {
      const photo = await AuthService.uploadPicHrdWs(input, file);
      setPhoto(photo);
      setShowMd4(false);
      if (photo.error) toast.error(photo.error);
    } catch (error) {}
  };

  const onUpload = async (file) => {
    if (props.item) {
      let input = {
        trainingid: props.item.TRAINING_ID
      };
      await uploadPicWs(input, file);
      await props.onRefresh(props.item);
    }
  };

  const downloadPhotoWs = async (planid) => {
    try {
      const photo = await AuthService.downloadPhotoHrd(planid, 'plan');
      if (photo.error) throw 'timeout';
      setPhoto(photo);
    } catch (error) {
      // props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadXlsx = (input, name) => {
    try {
      const transformedInput = input.map((row) => ({
        ...row,
        IS_PASSED:
          String(row.IS_PASSED).toLowerCase() === 'true'
            ? 1
            : String(row.IS_PASSED).toLowerCase() === 'false'
            ? 0
            : row.IS_PASSED
      }));

      const ws = utils.json_to_sheet(transformedInput);
      const wb = utils.book_new();
      utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = write(wb, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'array'
      });
      FileSaver.saveAs(
        new Blob([wbout], {type: 'application/octet-stream'}),
        `${name}.xlsx`
      );
    } catch (err) {
      console.error('export error', err);
    }
  };

  const onDelete = async (UPDATE_ON, EMPID) => {
    //copy props มาใช้ ไม่ต้องยุ่งกับ state
    const TRAINEE = props.TRAINEE.filter((e) => e.EMPID !== EMPID);

    const input = {
      ...training,
      UPDATE_ON: UPDATE_ON,
      TRAINEE: TRAINEE
    };
    await props.onUpdate(input);
  };

  const onDeleteTrainer = async (UPDATE_ON, EMPID) => {
    //copy props มาใช้ ไม่ต้องยุ่งกับ state
    const TRAINER = props.TRAINER.filter((e) => e.EMPID !== EMPID);

    const input = {
      ...training,
      UPDATE_ON: UPDATE_ON,
      TRAINER: TRAINER
    };
    await props.onUpdate(input);
  };

  const onEmail = async (EMPID) => {
    const TRAINEE =
      EMPID === 'ALL'
        ? props.TRAINEE
        : props.TRAINEE.filter((e) => e.EMPID == EMPID);
    const input = {
      ...training,
      TRAINEE: TRAINEE
    };
    await props.onEmail(input);
  };

  const onUpdate = async (UPDATE_ON) => {
    const offset = training.TRAINING_DATE.getTimezoneOffset();
    const thDate1 = new Date(
      training.TRAINING_DATE.getTime() - offset * 60 * 1000
    );
    const thDate2 = new Date(
      training.TRAINING_TIME_START.getTime() - offset * 60 * 1000
    );
    const thDate3 = new Date(
      training.TRAINING_TIME_END.getTime() - offset * 60 * 1000
    );

    const thDate4 = new Date(
      training.TRAINING_REG_START.getTime() - offset * 60 * 1000
    );
    const thDate5 = new Date(
      training.TRAINING_REG_END.getTime() - offset * 60 * 1000
    );

    const thDate6 = training.TRAINING_EXPIRED_DATE
      ? new Date(training.TRAINING_EXPIRED_DATE.getTime() - offset * 60 * 1000)
      : null;
    const input = {
      ...training,
      UPDATE_ON: UPDATE_ON,
      TRAINING_DATE: thDate1.toISOString().split('T')[0],
      TRAINING_TIME_START: thDate2.toISOString().split('T')[1].substring(0, 5),
      TRAINING_TIME_END: thDate3.toISOString().split('T')[1].substring(0, 5),
      TRAINING_REG_START: thDate4
        .toISOString()
        .replaceAll('T', ' ')
        .substring(0, 19),
      TRAINING_REG_END: thDate5
        .toISOString()
        .replaceAll('T', ' ')
        .substring(0, 19),
      TRAINING_EXPIRED_DATE: thDate6
        ? thDate6.toISOString().split('T')[0]
        : null
    };

    await props.onUpdate(input);
    handleReupload();
  };

  const onUpdateOne = async (UPDATE_ON) => {
    const input = {
      ...training,
      UPDATE_ON: UPDATE_ON,
      TRAINEE: [{EMPID: search3}]
    };
    await props.onUpdate(input);
    handleReupload();
    setSearch3('');
  };

  const handleReupload = async () => {
    setStep(1);
    setStepScore(1);
    setStepTrainer(1);
    setData([]);
    setData2([]);
    setData3([]);
  };

  const onValueChange = (index, value) => {
    let temp = training.EXPENSE.map((e) => {
      // if (e.value === index) return {...e, amount: parseInt(value)};
      if (e.value === index) return {...e, amount: parseFloat(value)};
      else return e;
    });

    setTrainging((prevState) => ({
      ...prevState,
      EXPENSE: temp
    }));
  };

  function mapOrder(array, order) {
    array.sort(function (a, b) {
      var A = a['EMPID'],
        B = b['EMPID'];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }
    });
    return array;
  }

  const fileUpload = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        let _res1 = await props.getFullData(res1);

        //เรียงตาม res1
        let item_order = res1.map((e) => `${e.EMPID}`);
        _res1 = mapOrder(_res1, item_order);

        setData(_res1);
        setTrainging((prevState) => ({
          ...prevState,
          TRAINEE: _res1
        }));
        setStep(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  const fileUpload3 = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile(file);
      if (res1.length > 0) {
        let _res1 = await props.getFullData(res1);
        _res1 = _res1.map((e, i) => {
          if (i === 0) return {...e, IS_MAIN: true};
          else return {...e, IS_MAIN: false};
        });

        const names = _res1.reduce((prev, curr) => {
          return `${prev}คุณ${curr.NAME}, `;
        }, '');

        setData3(_res1);
        setTrainging((prevState) => ({
          ...prevState,
          TRAINING_INSTRUCTOR: names,
          TRAINER: _res1
        }));
        setStepTrainer(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  const onSearch2 = async () => {
    if (search2 === '') {
      toast.warning('กรุณาใส่คำค้นหา');
    } else {
      const _members = await AuthService.downloadEmployees(search2);
      setMembers2(_members);
    }
  };

  const onAdd = async (empid, name, img) => {
    if (empid === user.ID_EMP) {
      toast.warning('ไม่ต้องเพิ่มตัวเอง');
    } else {
      if (members.find((e) => e.ID_Emp === empid)) {
        toast.warning('รายการซ้ำ ไม่สามารถเพิ่มได้');
      } else {
        let _temp = [
          ...members,
          {DisplayName: name, ID_Emp: empid, Image: img}
        ];
        setMembers(_temp);
        setTrainging((prevState) => ({
          ...prevState,
          RELATED: _temp
        }));
      }
    }
  };

  const onDeleteMember = async (empid) => {
    if (members.find((e) => e.ID_Emp === empid)) {
      let _temp = members.filter((e) => e.ID_Emp !== empid);
      setMembers(_temp);
      setTrainging((prevState) => ({
        ...prevState,
        RELATED: _temp
      }));
    } else {
      toast.warning('ไม่พบข้อมูล');
    }
  };

  const fileUpload2 = async (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      let res1 = await validateFile2(file);
      if (res1.length > 0) {
        let _res1 = await props.getFullData(res1);
        _res1 = _res1.map((e) => {
          return {
            ...e,
            PRE: res1.find((el) => el.EMPID == e.EMPID).PRE,
            POST: res1.find((el) => el.EMPID == e.EMPID).POST,
            IS_PASSED: res1.find((el) => el.EMPID == e.EMPID).IS_PASSED,
            SAFETY: res1.find((el) => el.EMPID == e.EMPID).SAFETY
          };
        });

        setData2(_res1);
        setTrainging((prevState) => ({
          ...prevState,
          SCORE: _res1
        }));
        setStepScore(2);
      } else {
        toast.error('Wrong file format!');
      }
    }
    e.target.value = null;
  };

  const validateFile = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json(worksheet);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1
      }));
      if (!jsonData[0].hasOwnProperty('EMPID')) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  const validateFile2 = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const workbook = read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      let jsonData = utils.sheet_to_json(worksheet);
      jsonData = jsonData.map((e, i) => ({
        ...e,
        index: i + 1
      }));
      if (
        !jsonData[0].hasOwnProperty('EMPID') ||
        !jsonData[0].hasOwnProperty('PRE') ||
        !jsonData[0].hasOwnProperty('POST')
      ) {
        throw 'error';
      }
      return jsonData;
    } catch {
      return [];
    }
  };

  const onSendMessage = async (message) => {
    if (props.item) {
      await uploadChatWs(props.item.TRAINING_ID, message);
    }
  };

  function addDays(date, days) {
    // var result = new Date(date);
    date.setDate(date.getDate() + days);
    return date;
  }

  const uploadChatWs = async (trainingid, message) => {
    try {
      //
      const chats = await AuthService.uploadChatHrd(trainingid, message);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      // props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const downloadChatWs = async (planid) => {
    try {
      const chats = await AuthService.downloadChatHrd(planid);
      if (chats.error) throw 'timeout';
      setChat(chats);
    } catch (error) {
      // props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  // const [state, setState] = useStateWithCallbackLazy({
  //   ROW_NO: '',
  //   id: 0,
  //   USERNAME: '',
  //   PASSWORD: '',
  //   NAME: '',
  //   TEL: '',
  //   EMAIL: '',
  //   COUNTRY_CODE: '',
  //   COMPANY_NAME: '',
  //   COMPANY_ADDR: '',
  //   COMPANY_NUMBER: '',
  //   GENDER: '',
  //   COMPANY_BRANCH: '',
  //   COMPANY_POSTCODE: '',
  //   SUP_NAME: '',
  //   IS_ACTIVE: '',
  //   REG_DATE: '',
  //   CHANNEL: '',
  //   AGE_RANGE: ''
  // });
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    //Edit เวลาก่อน
    const t1 = props.item.TRAINING_TIME_START
      ? props.item.TRAINING_TIME_START.substring(10, 23)
      : 'T00:00:00.000';
    const t2 = props.item.TRAINING_TIME_END
      ? props.item.TRAINING_TIME_END.substring(10, 23)
      : 'T00:00:00.000';

    const d1 = new Date(
      props.item.TRAINING_DATE
        ? props.item.TRAINING_DATE.substring(0, 10) + t1 + '+07:00'
        : '2024-01-01'
    );
    const d2 = new Date(
      props.item.TRAINING_DATE
        ? props.item.TRAINING_DATE.substring(0, 10) + t2 + '+07:00'
        : '2024-01-01'
    );
    const d4 = new Date(
      props.item.TRAINING_REG_START
        ? props.item.TRAINING_REG_START.replaceAll('Z', '+07:00')
        : '2024-01-01'
    );
    const d5 = new Date(
      props.item.TRAINING_REG_END
        ? props.item.TRAINING_REG_END.replaceAll('Z', '+07:00')
        : '2024-01-01'
    );

    const d6 = new Date(
      props.item.TRAINING_EXPIRED_DATE
        ? props.item.TRAINING_EXPIRED_DATE.replaceAll('Z', '+07:00')
        : '2024-01-01'
    );

    setTrainging({
      ...props.item,
      TRAINING_DATE: d1,
      TRAINING_TIME_START: d1,
      TRAINING_REG_START: d4,
      TRAINING_REG_END: d5,
      TRAINING_DATE2: d2,
      TRAINING_TIME_END: d2,
      TRAINING_EXPIRED_DATE: props.item.TRAINING_EXPIRED_DATE ? d6 : null,
      IS_CHECKED: props.item.TRAINING_EXPIRED_DATE !== null
    });
    setDropdownGroup(props.dropdownGroup);
    setDropdownTrainerType(props.dropdownTrainerType);
    setDropdownPlace(props.dropdownPlace);
    setDropdownType(props.dropdownType);
    setDropdownExpense(props.dropdownExpense);
    if (props.item) {
      downloadChatWs(props.item.TRAINING_ID);
      downloadPhotoWs(props.item.TRAINING_ID);
    }
  }, [props.item]);

  useEffect(() => {
    setTrainging((prevState) => ({
      ...prevState,
      EXPENSE: props.EXPENSE
    }));
  }, [props.EXPENSE]);

  useEffect(() => {
    setTrainging((prevState) => ({
      ...prevState,
      RELATED: props.RELATED
    }));

    setMembers(props.RELATED);
  }, [props.RELATED]);

  console.log('🔵🟠🟡', showMd4);
  return (
    <div className="row">
      <Modal
        show={showMd4}
        onHide={() => setShowMd4(false)}
        style={{zIndex: 9999}}
      >
        <Modal.Header closeButton>
          <Modal.Title>อัพโหลดรูปเพิ่มเติม</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalAddPic onUpload={onUpload}></ModalAddPic>
        </Modal.Body>
      </Modal>
      <div className="col-12 col-md-9">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="training" title="กรอกข้อมูล (1)">
            <div className="row">
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  as="textarea"
                  // type="text"
                  value={training.TRAINING_NAME}
                  placeholder={'หัวข้อการอบรม/ชื่อหลักสูตร'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_NAME: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  as="textarea"
                  value={training.TRAINING_GROUP_NAME}
                  placeholder={'ตำแหน่งผู้เรียน'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_GROUP_NAME: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  as="textarea"
                  value={training.TRAINING_DIVISION}
                  placeholder={'ฝ่ายงานผู้เรียน'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_DIVISION: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  as="textarea"
                  value={training.TRAINING_FIELD}
                  placeholder={'สายงานของผู้เรียน'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_FIELD: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  type="text"
                  disabled={parseInt(training.TRAINING_INSTRUCTOR_TYPE) !== 2}
                  value={training.TRAINING_INSTRUCTOR}
                  placeholder={
                    parseInt(training.TRAINING_INSTRUCTOR_TYPE) !== 2
                      ? 'ชื่อวิทยากรจะมาอัตโนมัติ'
                      : 'ชื่อวิทยากร'
                  }
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_INSTRUCTOR: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Form.Control
                  type="text"
                  value={training.TRAINING_VENUE}
                  placeholder={'สถานที่อบรม'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_VENUE: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Select
                  value={dropdownGroup.filter(
                    (e) => e.value === training.TRAINING_GROUP
                  )}
                  placeholder={'หมวดหลักสูตร'}
                  options={dropdownGroup}
                  onChange={(v) =>
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_GROUP: v.value
                    }))
                  }
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-3">
                <Select
                  value={dropdownTrainerType.filter(
                    (e) => e.value === training.TRAINING_INSTRUCTOR_TYPE
                  )}
                  placeholder={'ประเภทวิทยากร '}
                  options={dropdownTrainerType}
                  onChange={(v) =>
                    // setTrainging((prevState) => ({
                    //   ...prevState,
                    //   TRAINING_INSTRUCTOR_TYPE: v.value
                    // }))
                    {
                      setTrainging((prevState) => ({
                        ...prevState,
                        TRAINING_INSTRUCTOR_TYPE: v.value,
                        TRAINING_INSTRUCTOR:
                          v.value === '2' ? prevState.TRAINING_INSTRUCTOR : '',
                        TRAINING_INSTRUCTOR_NAME:
                          v.value === '2'
                            ? prevState.TRAINING_INSTRUCTOR_NAME
                            : ''
                      }));
                    }
                  }
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-3">
                <Form.Control
                  type="text"
                  disabled={parseInt(training.TRAINING_INSTRUCTOR_TYPE) !== 2}
                  value={training.TRAINING_INSTRUCTOR_NAME}
                  placeholder={'ชื่อสถาบัน/บริษัทวิทยากร'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_INSTRUCTOR_NAME: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-6">
                <Select
                  value={dropdownType.filter(
                    (e) => e.value === training.TRAINING_TYPE_V2
                  )}
                  placeholder={'รูปแบบการจัด'}
                  options={dropdownType}
                  onChange={(v) =>
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_TYPE_V2: v.value,
                      TRAINING_TYPE: v.value === '2' ? 'ON' : 'OFF'
                    }))
                  }
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-3">
                <Select
                  value={dropdownPlace.filter(
                    (e) => e.value === training.TRAINING_PLACE
                  )}
                  placeholder={'ประเภทการจัดอบรม'}
                  options={dropdownPlace}
                  onChange={(v) =>
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_PLACE: v.value
                    }))
                  }
                />
              </Form.Group>

              <Form.Group className="mb-2 col-md-3">
                <Form.Control
                  type="text"
                  value={training.TRAINING_CERT_NO}
                  placeholder={'Certificate No.'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_CERT_NO: e.target.value
                    }));
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-2 col-md-4">
                <Form.Label>วันเวลาเริ่มอบรม</Form.Label>
                <DateTimePicker
                  // disable={true}
                  // readOnly={true}
                  // showPickerIfReadOnly={true}
                  date={training.TRAINING_DATE}
                  // defaultDate={training.TRAINING_DATE}
                  format="YYYY-MM-DD HH:mm"
                  onChange={async (e) => {
                    const startDate = e.date.toDate();
                    setTrainging((prevState) => {
                      const expiredDate = new Date(startDate);
                      expiredDate.setFullYear(expiredDate.getFullYear() + 1);
                      expiredDate.setDate(expiredDate.getDate() - 1);
                      expiredDate.setHours(0, 0, 0, 0);

                      const endDate = new Date(startDate);
                      return {
                        ...prevState,
                        TRAINING_DATE: startDate,
                        TRAINING_TIME_START: startDate,
                        TRAINING_TIME_END: endDate,
                        TRAINING_EXPIRED_DATE: prevState.IS_CHECKED
                          ? expiredDate
                          : prevState.TRAINING_EXPIRED_DATE
                      };
                    });
                    setMin(e.date.toDate());
                    setMax(
                      addDays(e.date.toDate(), 1)
                        ? addDays(e.date.toDate(), 1)
                        : e.date.toDate()
                    );
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-2 col-md-4">
                <Form.Label>
                  วันเวลาที่สิ้นสุดอบรม (ให้เลือกวันเดียวกัน)
                </Form.Label>
                <DateTimePicker
                  // readOnly={true}
                  // showPickerIfReadOnly={true}
                  // disable={true}
                  // minDate={min}
                  // maxDate={max}
                  date={training.TRAINING_TIME_END}
                  format="YYYY-MM-DD HH:mm"
                  onChange={async (e) => {
                    setTrainging((prevState) => {
                      let hours =
                        Math.round(
                          (Math.abs(prevState.TRAINING_DATE - e.date.toDate()) /
                            36e5) *
                            2
                        ) / 2;

                      hours =
                        prevState.TRAINING_DATE.getHours() <= 12 &&
                        e.date.toDate().getHours() >= 13
                          ? hours - 1
                          : hours;
                      return {
                        ...prevState,
                        TRAINING_HOUR: hours,
                        TRAINING_TIME_END: e.date.toDate()
                      };
                    });
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-2">
                <Form.Label>รวมชั่วโมง</Form.Label>
                <Form.Control
                  type="number"
                  value={training.TRAINING_HOUR}
                  placeholder={'ชั่วโมงเรียน'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_HOUR: Number(e.target.value)
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-2">
                <Form.Label>คะแนนเต็ม</Form.Label>
                <Form.Control
                  type="number"
                  value={training.TRAINING_TOTAL_SCORE}
                  placeholder={'คะแนนเต็ม'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_TOTAL_SCORE: Number(e.target.value)
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-4">
                <Form.Label>วันที่เปิดลงนามผ่านแอฟฯ</Form.Label>
                <DateTimePicker
                  // readOnly={true}
                  // showPickerIfReadOnly={true}
                  // disable={true}
                  date={training.TRAINING_REG_START}
                  format="YYYY-MM-DD HH:mm"
                  onChange={async (e) => {
                    setTrainging((prevState) => {
                      return {
                        ...prevState,
                        TRAINING_REG_START: e.date.toDate()
                      };
                    });
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-4">
                <Form.Label>วันที่สิ้นสุดลงนามผ่านแอฟฯ</Form.Label>
                <DateTimePicker
                  // readOnly={true}
                  // showPickerIfReadOnly={true}
                  // disable={true}
                  date={training.TRAINING_REG_END}
                  format="YYYY-MM-DD HH:mm"
                  onChange={async (e) => {
                    setTrainging((prevState) => {
                      return {
                        ...prevState,
                        TRAINING_REG_END: e.date.toDate()
                      };
                    });
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-2 col-md-4">
                <Form.Label>วันหมดอายุของหลักสูตร</Form.Label>
                <InputGroup className="mb-3">
                  <div className="custom-datetime-picker">
                    <DateTimePicker
                      readOnly={!training.IS_CHECKED}
                      date={training.TRAINING_EXPIRED_DATE}
                      format="YYYY-MM-DD"
                      onChange={async (e) => {
                        setTrainging((prevState) => {
                          return {
                            ...prevState,
                            TRAINING_EXPIRED_DATE: e.date.toDate()
                          };
                        });
                      }}
                    />
                  </div>

                  <InputGroup.Text
                    style={{
                      borderRadius: '0rem 0.25rem 0.25rem 0rem',
                      borderLeft: 'none'
                    }}
                  >
                    <Form.Check
                      type="checkbox"
                      // checked={.current}
                      checked={training.IS_CHECKED}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        if (isChecked) {
                          const expiredDate = new Date(
                            training.TRAINING_DATE || new Date()
                          );
                          expiredDate.setFullYear(
                            expiredDate.getFullYear() + 1
                          );
                          expiredDate.setDate(expiredDate.getDate() - 1);
                          expiredDate.setHours(0, 0, 0, 0);

                          setTrainging((prevState) => ({
                            ...prevState,
                            TRAINING_EXPIRED_DATE: expiredDate,
                            IS_CHECKED: isChecked
                          }));
                        } else {
                          setTrainging((prevState) => ({
                            ...prevState,
                            TRAINING_EXPIRED_DATE: null,
                            IS_CHECKED: isChecked
                          }));
                        }
                      }}
                    />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-2 col-md-12">
                <Form.Control
                  type="text"
                  value={training.TRAINING_ZOOM_URL}
                  placeholder={'Link Zoom (ถ้ามี)'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_ZOOM_URL: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-12">
                <Form.Control
                  type="text"
                  value={training.TRAINING_DOC_URL}
                  placeholder={'Link เอกสาร (ถ้ามี)'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_DOC_URL: e.target.value
                    }));
                  }}
                />
              </Form.Group>
            </div>
            <Button
              onClick={() => {
                onUpdate('MAIN');
              }}
              className={
                props.showAdmin ||
                user.ID_EMP === props.item.BY_EMPID ||
                props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                  ? 'd-block'
                  : 'd-none'
              }
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab eventKey="trainee" title="ผู้เข้าอบรม (2)">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className={'card card-success'}>
                    <div className="card-header">
                      <h3 className="card-title">รายชื่อปัจจุบัน</h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            downloadXlsx(props.TRAINEE, 'export');
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={'card-body'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>C. AA(T)</th>
                            <th>C. AA(E)</th>
                            <th>C. NPS(T)</th>
                            <th>C. NPS(E)</th>
                            <th>ลบ</th>
                            <th>ส่งเมล</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.TRAINEE.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>
                                {x.NAME?.includes('ลาออก') ? (
                                  <span style={{backgroundColor: '#f79393ff'}}>
                                    {x.NAME}
                                  </span>
                                ) : (
                                  x.NAME
                                )}
                              </td>
                              <td>
                                <a
                                  href={`https://api-zoom-v2.advanceagro.net/pdfapi/cert/${
                                    props.item.TRAINING_ID
                                  }/${
                                    x['EMPID']
                                  }?lang=th&t=${localStorage.getItem(
                                    'gatekeeper_token'
                                  )}`}
                                  target="_blank"
                                >
                                  <i className="fas fa-print" />
                                </a>
                              </td>
                              <td>
                                <a
                                  href={`https://api-zoom-v2.advanceagro.net/pdfapi/cert/${
                                    props.item.TRAINING_ID
                                  }/${
                                    x['EMPID']
                                  }?lang=en&t=${localStorage.getItem(
                                    'gatekeeper_token'
                                  )}`}
                                  target="_blank"
                                >
                                  <i className="fas fa-print" />
                                </a>
                              </td>
                              <td>
                                <a
                                  href={`https://api-zoom-v2.advanceagro.net/pdfapi/cert/nps/${
                                    props.item.TRAINING_ID
                                  }/${
                                    x['EMPID']
                                  }?lang=th&t=${localStorage.getItem(
                                    'gatekeeper_token'
                                  )}`}
                                  target="_blank"
                                >
                                  <i className="fas fa-print" />
                                </a>
                              </td>
                              <td>
                                <a
                                  href={`https://api-zoom-v2.advanceagro.net/pdfapi/cert/nps/${
                                    props.item.TRAINING_ID
                                  }/${
                                    x['EMPID']
                                  }?lang=en&t=${localStorage.getItem(
                                    'gatekeeper_token'
                                  )}`}
                                  target="_blank"
                                >
                                  <i className="fas fa-print" />
                                </a>
                              </td>
                              <td>
                                <a>
                                  <i
                                    className="fas fa-trash text-danger"
                                    style={{cursor: 'pointer'}}
                                    onClick={(e) => {
                                      onDelete('TRAINEE', x.EMPID);
                                    }}
                                  />
                                </a>
                              </td>
                              <td>
                                <a>
                                  <i
                                    className="fas fa-envelope"
                                    style={{cursor: 'pointer'}}
                                    onClick={(e) => {
                                      onEmail(x.EMPID);
                                    }}
                                  />
                                </a>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="row">
                        <input
                          value={search3}
                          type="text"
                          onChange={(event) => {
                            event.preventDefault();
                            setSearch3(event.target.value);
                          }}
                          className="form-control col-6 m-2"
                          placeholder="รหัสพนักงาน"
                        />
                        <Button
                          variant="info"
                          onClick={() => {
                            onUpdateOne('TRAINEEONE');
                          }}
                          className={
                            props.showAdmin ||
                            user.ID_EMP === props.item.BY_EMPID ||
                            props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                              ? 'd-block m-2'
                              : 'd-none m-2'
                          }
                        >
                          เพิ่ม 1 คน
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={
                      step === 1 ? 'card card-primary' : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 1 : อัพโหลด Excel
                        (รายการเก่าจะหายและถูกแทนที่ด้วยของใหม่ทั้งหมด)
                      </h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            window
                              .open(
                                'https://api-passport.advanceagro.net/file/Training.xlsx',
                                '_blank'
                              )
                              ?.focus();
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={step === 1 ? 'card-body' : 'card-body d-none'}
                    >
                      <Form.Group className="mb-3 col-md-9">
                        <Form.Control
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={fileUpload}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div
                    className={
                      step === 2 ? 'card card-primary' : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 2 : ตรวจความถูกต้อง
                      </h3>
                    </div>
                    <div
                      className={step === 2 ? 'card-body' : 'card-body d-none'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            {/* <th>กลุ่ม</th>
                          <th>แผนก</th>
                          <th>บริษัท</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              {/* <td>{x['SECTION']}</td>
                            <td>{x['DEPARTMENT']}</td>
                            <td>{x['COMPANY']}</td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <div className="row mt-2">
                        <Button
                          className="col-md-12"
                          variant="warning"
                          block
                          type="button"
                          onClick={handleReupload}
                        >
                          {'ไม่ถูกต้อง, อัพโหลดใหม่'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Button
                disabled={data.length == 0}
                onClick={() => {
                  onUpdate('TRAINEE');
                }}
                className={
                  props.showAdmin ||
                  user.ID_EMP === props.item.BY_EMPID ||
                  props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                    ? 'd-block'
                    : 'd-none'
                }
              >
                บันทึกแก้ไข
              </Button>
              <Button
                // disabled={props.isSending ? props.isSending : false}
                // loading={props.isSending ? props.isSending : false}
                // theme="success"
                variant="success"
                className="col-2 ml-1"
                disabled={props.TRAINEE == 0 || props.isSending}
                onClick={() => {
                  onEmail('ALL');
                }}
              >
                {props.isSending && (
                  <Spinner as="span" animation="border" size="sm" />
                )}
                {props.isSending
                  ? ` กำลังส่ง (${props.countDown})`
                  : 'ส่งอีเมล'}
              </Button>
            </div>
          </Tab>
          <Tab eventKey="email" title="หัวข้ออีเมล (3)">
            <div className="row">
              <Form.Group className="mb-2 col-md-12">
                <Form.Control
                  as="textarea"
                  // type="text"
                  value={training.MAIL_SUBJECT}
                  placeholder={'หัวอีเมล'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      MAIL_SUBJECT: e.target.value
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-12">
                <Form.Control
                  as="textarea"
                  // type="text"
                  value={training.MAIL_BODY}
                  placeholder={'ข้อความส่วนต้นอีเมล'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      MAIL_BODY: e.target.value
                    }));
                  }}
                />
              </Form.Group>
            </div>
            <Button
              onClick={() => {
                onUpdate('MAIN');
              }}
              className={
                props.showAdmin ||
                user.ID_EMP === props.item.BY_EMPID ||
                props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                  ? 'd-block'
                  : 'd-none'
              }
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab eventKey="expense" title="ค่าใช้จ่าย (4)">
            <div className="row">
              <Form.Group className="mb-3 col-md-12">
                <Select
                  isMulti
                  value={dropdownExpense.filter((e) =>
                    training.EXPENSE.find((el) => el.value == e.value)
                  )}
                  // menuPlacement="top"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder={'ค่าใช้จ่ายอื่นๆ'}
                  options={dropdownExpense}
                  onChange={(v) => {
                    const _temp = v.map((e) => ({
                      ...e,
                      amount: 0,
                      selected: true,
                      unit: 'บาท'
                    }));
                    setTrainging((prevState) => ({
                      ...prevState,
                      EXPENSE: _temp
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-12">
                <SelectedBox
                  selected={training.EXPENSE}
                  // selected={[]}
                  onValueChange={onValueChange}
                />
              </Form.Group>
            </div>
            <Button
              onClick={() => {
                onUpdate('EXPENSE');
              }}
              className={
                props.showAdmin ||
                user.ID_EMP === props.item.BY_EMPID ||
                props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                  ? 'd-block'
                  : 'd-none'
              }
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab
            eventKey="trainer-inhouse"
            title="วิทยากรภายใน (5)"
            disabled={parseInt(training.TRAINING_INSTRUCTOR_TYPE) === 2}
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className={'card card-success'}>
                    <div className="card-header">
                      <h3 className="card-title">
                        รายชื่อวิทยากรปัจจุบัน [คนหลักคือคนแรกเสมอ]
                      </h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            downloadXlsx(props.TRAINER, 'export');
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={'card-body'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>คนหลัก</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.TRAINER.sort((a, b) => {
                            return a.IS_MAIN ? -1 : b.IS_MAIN ? 1 : 0;
                          }).map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              <td>
                                <input
                                  disabled={true}
                                  type="checkbox"
                                  checked={x.IS_MAIN}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={
                      stepTrainer === 1
                        ? 'card card-primary'
                        : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 1 : อัพโหลด Excel
                        (รายการเก่าจะหายและถูกแทนที่ด้วยของใหม่ทั้งหมด)
                      </h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            window
                              .open(
                                'https://api-passport.advanceagro.net/file/Training.xlsx',
                                '_blank'
                              )
                              ?.focus();
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={
                        stepTrainer === 1 ? 'card-body' : 'card-body d-none'
                      }
                    >
                      <Form.Group className="mb-3 col-md-9">
                        <Form.Control
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={fileUpload3}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div
                    className={
                      stepTrainer === 2
                        ? 'card card-primary'
                        : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 2 : ตรวจความถูกต้อง [คนหลักคือคนแรกเสมอ]
                      </h3>
                    </div>
                    <div
                      className={
                        stepTrainer === 2 ? 'card-body' : 'card-body d-none'
                      }
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>คนหลัก</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data3
                            .sort((a, b) => {
                              return a.IS_MAIN ? -1 : b.IS_MAIN ? 1 : 0;
                            })
                            .map((x, i) => (
                              <tr key={`v-${i}`}>
                                <td>{i + 1}</td>
                                <td>{x['EMPID']}</td>
                                <td>{x['NAME']}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={x['IS_MAIN']}
                                    onChange={(e) => {
                                      //update data3, training
                                      const _temp = data3.map((el) => {
                                        if (el.EMPID === x['EMPID'])
                                          return {
                                            ...el,
                                            IS_MAIN: e.target.checked
                                          };
                                        else return el; //else return {...el, IS_MAIN: false};
                                      });

                                      setData3(_temp);
                                      setTrainging((prevState) => ({
                                        ...prevState,
                                        TRAINER: _temp
                                      }));
                                    }}
                                  />
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </Table>

                      <div className="row mt-2">
                        <Button
                          className="col-md-12"
                          variant="warning"
                          block
                          type="button"
                          onClick={handleReupload}
                        >
                          {'ไม่ถูกต้อง, อัพโหลดใหม่'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Button
                disabled={data3.length == 0}
                onClick={() => {
                  onUpdate('TRAINER');
                }}
                className={
                  props.showAdmin ||
                  user.ID_EMP === props.item.BY_EMPID ||
                  props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                    ? 'd-block'
                    : 'd-none'
                }
              >
                บันทึกแก้ไข
              </Button>
            </div>
          </Tab>
          <Tab eventKey="score" title="คะแนน pre-post (6)" disabled={false}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                  <div className={'card card-success'}>
                    <div className="card-header">
                      <h3 className="card-title">คะแนนปัจจุบัน</h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            downloadXlsx(props.SCORE, 'export');
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={'card-body'}
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>Pre</th>
                            <th>Post</th>
                            <th>Passed</th>
                            <th>ลบ</th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.SCORE.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              <td>{x['PRE'] ? x['PRE'] : '-'}</td>
                              <td>{x['POST'] ? x['POST'] : '-'}</td>
                              <td>
                                {x['IS_PASSED'] === true ? (
                                  <i
                                    className="fas fa-check-circle"
                                    style={{color: 'green'}}
                                  ></i>
                                ) : x['IS_PASSED'] === false ? (
                                  <i
                                    className="fas fa-times-circle"
                                    style={{color: 'red'}}
                                  ></i>
                                ) : (
                                  ''
                                )}
                              </td>
                              <td>
                                <a>
                                  <i
                                    className={
                                      x['PRE'] && x['POST']
                                        ? 'fas fa-trash'
                                        : 'd-none'
                                    }
                                    style={{cursor: 'pointer'}}
                                    onClick={(e) => {
                                      onDelete('SCORE', x.EMPID);
                                    }}
                                  />
                                </a>
                              </td>
                              {/* <td>{x['SECTION']}</td>
                            <td>{x['DEPARTMENT']}</td>
                            <td>{x['COMPANY']}</td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div
                    className={
                      stepScore === 1
                        ? 'card card-primary'
                        : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 1 : อัพโหลด Excel
                        (รายการเก่าจะหายและถูกแทนที่ด้วยของใหม่ทั้งหมด)
                      </h3>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            window
                              .open(
                                'https://itservice.advanceagro.net/authority/doc/ScoreNPS.xlsx',
                                '_blank'
                              )
                              ?.focus();
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i
                            className="fa fa-file-csv"
                            style={{color: '#fef200'}}
                          />
                        </button>
                      </div>
                      <div className="card-tools">
                        <button
                          onClick={() => {
                            window
                              .open(
                                'https://api-passport.advanceagro.net/file/Score.xlsx',
                                '_blank'
                              )
                              ?.focus();
                          }}
                          type="button"
                          className="btn btn-tool"
                        >
                          <i className="fa fa-file-csv" />
                        </button>
                      </div>
                    </div>
                    <div
                      className={
                        stepScore === 1 ? 'card-body' : 'card-body d-none'
                      }
                    >
                      <Form.Group className="mb-3 col-md-9">
                        <Form.Control
                          type="file"
                          accept=".xlsx, .xls"
                          onChange={fileUpload2}
                        />
                      </Form.Group>
                    </div>
                  </div>
                  <div
                    className={
                      stepScore === 2
                        ? 'card card-primary'
                        : 'card collapsed-card'
                    }
                  >
                    <div className="card-header">
                      <h3 className="card-title">
                        ขั้นตอนที่ 2 : ตรวจความถูกต้อง
                      </h3>
                    </div>
                    <div
                      className={
                        stepScore === 2 ? 'card-body' : 'card-body d-none'
                      }
                      style={{
                        height: '56vh',
                        width: '100%',
                        overflowY: 'scroll'
                      }}
                    >
                      <Table striped>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>รหัสพนักงาน</th>
                            <th>ชื่อ-สกุล</th>
                            <th>Pre</th>
                            <th>Post</th>
                            <th>Passed</th>
                            {/* <th>กลุ่ม</th>
                          <th>แผนก</th>
                          <th>บริษัท</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {data2.map((x, i) => (
                            <tr key={`v-${i}`}>
                              <td>{i + 1}</td>
                              <td>{x['EMPID']}</td>
                              <td>{x['NAME']}</td>
                              <td>{x['PRE']}</td>
                              <td>{x['POST']}</td>
                              <td>{x['IS_PASSED']}</td>
                              {/* <td>{x['SECTION']}</td>
                            <td>{x['DEPARTMENT']}</td>
                            <td>{x['COMPANY']}</td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <div className="row mt-2">
                        <Button
                          className="col-md-12"
                          variant="warning"
                          block
                          type="button"
                          onClick={handleReupload}
                        >
                          {'ไม่ถูกต้อง, อัพโหลดใหม่'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Button
              disabled={data2.length == 0}
              onClick={() => {
                onUpdate('SCORE');
              }}
              className={
                props.showAdmin ||
                user.ID_EMP === props.item.BY_EMPID ||
                props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                  ? 'd-block'
                  : 'd-none'
              }
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab eventKey="rating" title="ประเมินความพึงพอใจ (7)">
            <div className="row">
              <Form.Group className="mb-2 col-md-2">
                <Form.Label>คะแนนความพอใจ</Form.Label>
                <Form.Control
                  type="number"
                  value={
                    training.TRAINING_RATING ? training.TRAINING_RATING : 0
                  }
                  placeholder={'คะแนนความพอใจ'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_RATING: Number(e.target.value)
                    }));
                  }}
                />
              </Form.Group>
              <Form.Group className="mb-2 col-md-12">
                <Form.Label>ความเห็น</Form.Label>
                <Form.Control
                  // type="number"
                  as="textarea"
                  value={
                    training.TRAINING_COMMENT ? training.TRAINING_COMMENT : ''
                  }
                  placeholder={'ความเห็น'}
                  onChange={(e) => {
                    setTrainging((prevState) => ({
                      ...prevState,
                      TRAINING_COMMENT: e.target.value
                    }));
                  }}
                />
              </Form.Group>
            </div>
            <Button
              onClick={() => {
                onUpdate('MAIN');
              }}
              className={
                props.showAdmin ||
                user.ID_EMP === props.item.BY_EMPID ||
                props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                  ? 'd-block'
                  : 'd-none'
              }
            >
              บันทึกแก้ไข
            </Button>
          </Tab>
          <Tab eventKey="gallery" title={`ไฟล์อัพโหลดรูป (8)`}>
            <PhotoStamp
              images={photo}
              style={style}
              setStyle={setStyle}
            ></PhotoStamp>
          </Tab>
          <Tab eventKey="related" title="Related HRD (9)">
            <div className="container-fluid">
              <div className={'card card-primary'}>
                <div className="card-header">
                  <h3 className="card-title">
                    รายการนี้จะให้เห็นกับ Admin, Owner, และ Related HRD เท่านั้น
                    (ไม่ต้องเพิ่มตัวเอง)
                  </h3>
                </div>
                <div className={'card-body'}>
                  <div className="row">
                    <div className="col-6">
                      <Card className="card">
                        <Card.Header className="d-flex">
                          ค้นจากชื่อ รหัสพนักงาน หรืออีเมล์
                        </Card.Header>
                        <Card.Body>
                          <div className="col-12 mb-1">
                            <div className="ml-auto row">
                              <div className="input-group">
                                <input
                                  value={search2}
                                  type="text"
                                  onChange={(event) => {
                                    event.preventDefault();
                                    setSearch2(event.target.value);
                                  }}
                                  className="form-control"
                                  placeholder="ชื่อหรือรหัสพนักงาน"
                                />
                                <div className="input-group-append">
                                  <button
                                    className="btn btn-outline-secondary"
                                    type="button"
                                    onClick={onSearch2}
                                  >
                                    ค้นหา
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 p-1 container"
                            style={{
                              height: '39vh',
                              width: '100%',
                              overflowY: 'scroll'
                            }}
                          >
                            {members2.map((e, i) => (
                              <ItemMember
                                onAdd={onAdd}
                                onDelete={onDeleteMember}
                                mode={'add'}
                                key={`m-${i}`}
                                name={e.DisplayName}
                                empid={e.ID_Emp}
                                img={e.Image}
                                index={i + 1}
                              />
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                    <div className="col-6">
                      <Card className="card">
                        <Card.Header className="d-flex">
                          สมาชิกปัจจุบัน
                        </Card.Header>
                        <Card.Body>
                          <div
                            className="col-12 p-1 container"
                            style={{
                              height: '44vh',
                              width: '100%',
                              overflowY: 'scroll'
                            }}
                          >
                            {members.map((e, i) => (
                              <ItemMember
                                onAdd={onAdd}
                                onDelete={onDeleteMember}
                                mode={'delete'}
                                key={`m-${i}`}
                                name={e.DisplayName}
                                empid={e.ID_Emp}
                                img={e.Image}
                                index={i + 1}
                              />
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <Button
                onClick={() => {
                  onUpdate('RELATED');
                }}
                className={
                  props.showAdmin ||
                  user.ID_EMP === props.item.BY_EMPID ||
                  props.RELATED.find((e) => e.ID_Emp === user.ID_EMP)
                    ? 'd-block'
                    : 'd-none'
                }
              >
                บันทึกแก้ไข
              </Button>
            </div>
          </Tab>
          <Tab
            eventKey="folklift"
            title={`Folklift & Roll Clamp (10)`}
            disabled={training.TRAINING_GROUP !== '6'}
          >
            <FolkliftCers
              trainee={props.TRAINEE}
              trainer={props.TRAINER}
              score={props.SCORE}
              item={props.item}
            />
          </Tab>
        </Tabs>
      </div>
      <div className="col-12 col-md-3">
        <DirectChat
          isPublic={true}
          onOpenUpload={setShowMd4}
          panel={panel}
          messages={chat}
          onAgree={() => {}}
          onReject={() => {}}
          onEdit={() => {}}
          onCancel={() => {}}
          onSendMessage={onSendMessage}
        ></DirectChat>
      </div>
      <p
        className="text-danger col-md-12 content"
        dangerouslySetInnerHTML={{__html: error}}
      ></p>
    </div>
  );
}
